import CommonBackend, {
  CommonTranslationBackendOptions,
} from '@kartdavid/i18n/dist'
import axios from 'axios'
import i18n, {
  BackendModule,
  InitOptions,
  ReadCallback,
  Services,
  TOptions,
} from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-chained-backend'
import { initReactI18next } from 'react-i18next'
import YAML from 'yaml'

import { regionFromPath } from './util'

declare const BRAND: string

const myDetector = {
  name: BRAND,
  lookup: (options: any) => {
    return BRAND === 'kartdavid' ? 'en' : regionFromPath()
  },
  cacheUserLanguage: (lng: any, options: any) => {
    console.log('cacheUserLanguage', lng, options)
    // options -> are passed in options
    // lng -> current language, will be called after init and on changeLanguage
    // store it
  },
}

export interface YAMLLoaderBackendOptions {}
export class YAMLLoaderBackend
  implements BackendModule<YAMLLoaderBackendOptions> {
  type!: 'backend'

  constructor() {
    this.type = 'backend'
  }

  init(
    _services: Services,
    backendOptions: TOptions,
    _i18nextOptions: InitOptions
  ) {
    console.log('YAMLLoaderBackend')
    /*services:any, backendOptions: any, i18nextOptions: any*/
  }

  read(language: string, namespace: string, callback: ReadCallback) {
    const forLanguage = language.toLowerCase()

    console.log('YAMLLoaderBackend', forLanguage, namespace)

    axios
      .get(`/wp-json/${BRAND}/v1/locales/${forLanguage}/${namespace}.yaml`, {
        responseType: 'text',
      })
      .then((resp) => {
        const parsed = YAML.parse(resp.data)

        callback(null, parsed)
      })
      .catch((err) => {
        callback(err, null)
      })
  }

  save(language: string, namespace: string, data: any) {
    // store the translations
    return
  }

  create(languages: any, namespace: any, key: any, fallbackValue: any) {
    /* save the missing translation */
    return
  }
}

const languageLoader = new LanguageDetector(null, {
  order: [BRAND],
})
languageLoader.addDetector(myDetector)

const commonBackendOpts: CommonTranslationBackendOptions = {
  namespacePrefix: 'common',
}

const i18nInstance = i18n
  .createInstance({
    backend: {
      backends: [new CommonBackend(), new YAMLLoaderBackend()],
      backendOptions: [commonBackendOpts],
    },
    fallbackLng: 'en-gb',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    lowerCaseLng: true,
    load: 'currentOnly',
  })
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageLoader)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init()

export default i18nInstance
